import ResponseStatus from "./api";

/**
 * Card replacement feature constants
 *
 * Card replacement occurs when order has:
 * - status = "FUTURE"
 * - isPaymentScheduled = true
 */

/** Feature flag - set to false to disable feature */
export const CARD_REPLACEMENT_ENABLED = true;

/** Order status that indicates scheduled payment */
export const CARD_REPLACEMENT_STATUS = ResponseStatus.FUTURE;

/** Debug label for logging */
export const CARD_REPLACEMENT_DEBUG_LABEL = "CardReplacement";

export const CardReplacementConstants = {
  ENABLED: CARD_REPLACEMENT_ENABLED,
  STATUS: CARD_REPLACEMENT_STATUS,
  DEBUG_LABEL: CARD_REPLACEMENT_DEBUG_LABEL,
} as const;

export default CardReplacementConstants;
